import { render, staticRenderFns } from "./FilesComponent.vue?vue&type=template&id=bd6e274c&"
import script from "./FilesComponent.vue?vue&type=script&lang=js&"
export * from "./FilesComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports